import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AdminProvider } from './context/AdminContext';
import AdminLogin from './components/AdminLogin';
import AdminRoute from './components/AdminRoute';
import AdminConversationsPage from './pages/AdminConversationsPage';
import AdminChatViewing from './pages/AdminChatViewing';
import Layout from './components/Layout';

function App() {
  return (
    <Router>
      <AdminProvider>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<AdminLogin />} />
          
          {/* Protected Routes */}
          <Route element={<AdminRoute />}>
            <Route element={<Layout />}>
              <Route path="/conversations" element={<AdminConversationsPage />} />
              <Route path="/chat/:id" element={<AdminChatViewing />} />
            </Route>
          </Route>
          
          {/* Default redirects */}
          <Route path="/" element={<Navigate to="/conversations" replace />} />
          <Route path="*" element={<Navigate to="/conversations" replace />} />
        </Routes>
      </AdminProvider>
    </Router>
  );
}

export default App;
